import React, { useEffect, useContext, useMemo, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { AuthContext } from "../../context/AuthContext";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarHeader,
  SidebarBrand,
  SidebarLogoImg,
  SidebarBody,
  SidebarMenu,
  SidebarLinkR,
  SidebarBtnWrap,
  SidebarButton,
  Divider,
} from "./SidebarElements";

import LogoPng from "../../image/icon.png";

const normalizeRole = (role) => {
  if (!role) return "client";
  if (role === "driver") return "chauffeur";
  return role;
};

const Sidebar = ({ isOpen, toggle }) => {
  const { isAuthenticated, logout, role } = useContext(AuthContext);

  const [userType, setUserType] = useState(
    normalizeRole(localStorage.getItem("userType"))
  );

  const normalizedRole = useMemo(() => {
    return normalizeRole(role || userType || localStorage.getItem("userType"));
  }, [role, userType]);

  const isDriver = isAuthenticated && normalizedRole === "chauffeur";

  useEffect(() => {
    AOS.init({
      duration: 700,
      once: false,
      mirror: false,
    });
  }, []);

  useEffect(() => {
    if (isOpen) {
      AOS.refresh();
    }
  }, [isOpen]);

  useEffect(() => {
    const syncUserType = () => {
      setUserType(normalizeRole(localStorage.getItem("userType")));
    };

    window.addEventListener("storage", syncUserType);
    window.addEventListener("userTypeChanged", syncUserType);

    syncUserType();

    return () => {
      window.removeEventListener("storage", syncUserType);
      window.removeEventListener("userTypeChanged", syncUserType);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    localStorage.removeItem("userType");
    setUserType("client");
    toggle?.();
    window.location.href = "/";
  };

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) toggle?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, toggle]);

  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>

      <SidebarWrapper onClick={(e) => e.stopPropagation()}>
        <SidebarHeader data-aos="fade-right">
          <SidebarBrand to="/" onClick={toggle}>
            <SidebarLogoImg src={LogoPng} alt="Logo" />
          </SidebarBrand>
        </SidebarHeader>

        <SidebarBody>
          <SidebarMenu>
            <div data-aos="fade-left" data-aos-delay="50">
              <SidebarLinkR to="/" onClick={toggle}>
                Accueil
              </SidebarLinkR>
            </div>

            <div data-aos="fade-left" data-aos-delay="100">
              <SidebarLinkR to="/contact" onClick={toggle}>
                Contact
              </SidebarLinkR>
            </div>

            {isAuthenticated && (
              <>
                <div data-aos="fade-left" data-aos-delay="150">
                  <SidebarLinkR to="/news" onClick={toggle}>
                    News
                  </SidebarLinkR>
                </div>

                <div data-aos="fade-left" data-aos-delay="200">
                  <SidebarLinkR to="/avis" onClick={toggle}>
                    Avis
                  </SidebarLinkR>
                </div>

                {isDriver && (
                  <div data-aos="fade-left" data-aos-delay="250">
                    <SidebarLinkR to="/mes-documents" onClick={toggle}>
                      Mes Documents
                    </SidebarLinkR>
                  </div>
                )}

                <div data-aos="fade-left" data-aos-delay="300">
                  <SidebarLinkR to="/profile" onClick={toggle}>
                    Profil
                  </SidebarLinkR>
                </div>
              </>
            )}
          </SidebarMenu>

          <Divider />

          <SidebarBtnWrap data-aos="fade-up" data-aos-delay="350">
            {!isAuthenticated ? (
              <SidebarButton to="/signin" onClick={toggle}>
                Connexion
              </SidebarButton>
            ) : (
              <SidebarButton to="/" onClick={handleLogout} $danger>
                Déconnexion
              </SidebarButton>
            )}
          </SidebarBtnWrap>
        </SidebarBody>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;